import { queryOptions } from '@tanstack/react-query';
import { apiClient } from '@/libs/axios';
import { toMeDTO } from '../schemas/get-me.schema';

export const getMe = async () => {
  const url = '/auth/me';
  const response = await apiClient.get(url);

  return toMeDTO(response);
};

export const GET_ME_QUERY_KEY = 'get-me';

export const getMeQueryOptions = () =>
  queryOptions({
    queryKey: [GET_ME_QUERY_KEY],
    queryFn: getMe,
  });
